//For User Reducer Only
export const updateUserObjectWithNesting = (oldState, objectForUpdating) => {
  return {
    //Reducers are pure functions, updating referenced types immutably is strongly recommended
    ...oldState, //spread operator to clone
    ...objectForUpdating,
    userData: {
      ...objectForUpdating.userData, //spread operator to clone nested objects (Deep cloning in this case)
      profile: {
        ...objectForUpdating.userData.profile,
      },
    },
  };
};
